import React from 'react';
import { Layout } from 'antd';
import { userHooks } from 'hooks';
import { IRoute } from 'data';
import AppSider from './AppSider';
import AppHeader from './AppHeader';
import AppContent from './AppContent';
import './AppLayout.scss';

export interface AppLayoutProps {
  routes: IRoute[];
  customHeader?: React.ReactElement;
}

const AppLayout: React.FC<AppLayoutProps> = (props: AppLayoutProps) => {
  const { filteredNavigation, filteredRoutes } = userHooks.useAuthorizationData(
    props.routes as IRoute[]
  );

  return (
    <Layout className="app-layout">
      <AppHeader>{props.customHeader}</AppHeader>
      <div className="app-header-placeholder" />
      <Layout>
        <AppSider filteredNavigation={filteredNavigation} />
        <AppContent filteredRoutes={filteredRoutes} />
      </Layout>
    </Layout>
  );
};

export default AppLayout;
